import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  flexCol: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(1, 2),
    borderRadius: 4,
    transition: 'height 0.4s ease',
    overflow: 'hidden',
    marginBottom: 8,
  },
  overlineText: {
    marginBottom: theme.spacing(1),
  },
  flexRow: {
    height: 52,
    paddingLeft: theme.spacing(2),
    outline: 'none',
    borderRadius: 4,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.border.light}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    transition: 'height 0.4s ease',
    overflow: 'hidden',
  },
}));
